import React, { useEffect, useState } from "react";
import { Card, Box, Typography, CircularProgress } from "@mui/material";
import { DashboardApi } from "../../../api/DashboardApi";
import OrganizationLocationMap from "./OrganizationLocationMap";

export default function UsageMapPanel() {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrganizations = async () => {
            try {
                const result = await DashboardApi.getOrganizationList();
                setOrganizations(result ?? []);
            } catch (err) {
                console.error("Failed to fetch organization list", err);
                setError("Failed to load organization data.");
            } finally {
                setLoading(false);
            }
        };

        fetchOrganizations();
    }, []);

    return (
        <Card variant="outlined" sx={{
            height: "100%", borderRadius: 0,
            display: "flex", flexDirection: "column", backgroundColor: "black",
        }}>
            <Box sx={{ px: 2, pb: 2, flex: 1, minHeight: 0 }}>
                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Typography color="error">{error}</Typography>
                    </Box>
                ) : (
                    <OrganizationLocationMap organizations={organizations} />
                )}
            </Box>
        </Card>
    );
}